/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

@tagName('')
export default class SaveButton extends Component {
  actionAbstract = null;
  saveTask = null;
  isSaving = false;
  hasReadOnlyPermission = false;
}
